// extracted by mini-css-extract-plugin
export default {"add":"AddProduct_add__T0jY6"};